import { render, staticRenderFns } from "./CustomerUploads.vue?vue&type=template&id=c4e78ce2"
import script from "./CustomerUploads.vue?vue&type=script&lang=js"
export * from "./CustomerUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports